/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type PatientFileDto = {
    id: string;
    fileName: string;
    uploadedAt: string;
    uploadedBy: PatientFileDto.uploadedBy;
    visibleToSite: boolean;
}

export namespace PatientFileDto {

    export enum uploadedBy {
        PATIENT = 'PATIENT',
        HCP = 'HCP',
    }


}
